import { CompletePitchData } from "../types/StrikeZone";

const pitchOne: CompletePitchData = {
  isChallenge: false,
  isStrike: false,
  xCoord: -0.0737998,
  zCoord: 3.7377,
  szTop: 3.3129,
  szBottom: 1.659,
  pitchHand: "R",
  szWidth: 17,
  type: "Changeup",
  speed: 82.0,
  x0: 0,
  y0: 0,
  z0: 0,
  vx0: 0,
  vy0: 0,
  vz0: 0,
  ax: 0,
  ay: 0,
  az: 0,
  inPlay: false,
};

const pitchTwo: CompletePitchData = {
  isChallenge: false,
  isStrike: true,
  xCoord: 0.51481,
  zCoord: 2.598,
  pitchHand: "L",
  szTop: 3.3129,
  szBottom: 1.65699,
  szWidth: 17,
  type: "Four-seam FB",
  speed: 103.2,
  x0: 0,
  y0: 0,
  z0: 0,
  vx0: 0,
  vy0: 0,
  vz0: 0,
  ax: 0,
  ay: 0,
  az: 0,
  inPlay: false,
};

const pitchThree: CompletePitchData = {
  isChallenge: false,
  isStrike: false,
  xCoord: -0.418,
  zCoord: 1.2586,
  pitchHand: "R",
  szTop: 3.407,
  szBottom: 1.7029,
  szWidth: 17,
  type: "Slider",
  speed: 86.3,
  x0: 0,
  y0: 0,
  z0: 0,
  vx0: 0,
  vy0: 0,
  vz0: 0,
  ax: 0,
  ay: 0,
  az: 0,
  inPlay: true,
  exitVelocity: 82.3,
  launchAngle: 20.2,
};

export const MockPitches: CompletePitchData[] = [pitchOne, pitchTwo, pitchThree];
